import React, { PropTypes } from 'react';

const Avdelare = ({value}) => {
    

const student_desk = require("./img/student_desk_gray.gif");
const student_mob = require("./img/student_mob_gray.gif");  
const anstallning_desk = require("./img/anstallning_desk_gray.gif");
const anstallning_mob = require("./img/anstallning_mob_gray.gif");    
const mil_desk = require("./img/mil_desk_gray.gif");
const mil_mob = require("./img/mil_mob_gray.gif");    
const soffa_desk = require("./img/soffa_desk_gray.gif");
const soffa_mob = require("./img/soffa_mob_gray.gif");    
const kontakter_desk = require("./img/kontakter_desk_gray.gif");
const kontakter_mob = require("./img/kontakter_mob_gray.gif");    
const koket_desk = require("./img/koket_desk_gray.gif");
const koket_mob = require("./img/koket_mob_gray.gif");    

    
const textbox = (value && value.text);
const bild = (value && value.bild);
var bytbild_d,
    bytbild_m;

if (bild === 'student'){
    bytbild_d = student_desk;
    bytbild_m = student_mob;
} else if (bild === 'anstallning'){
    bytbild_d = anstallning_desk;
    bytbild_m = anstallning_mob;
}else if (bild === 'mil'){
    bytbild_d = mil_desk;
    bytbild_m = mil_mob;
}else if (bild === 'soffa'){
    bytbild_d = soffa_desk;
    bytbild_m = soffa_mob;
}else if (bild === 'kontakter'){
    bytbild_d = kontakter_desk;
    bytbild_m = kontakter_mob;
}else if (bild === 'koket'){
    bytbild_d = koket_desk;
    bytbild_m = koket_mob;
}
    
  const style = require('./Avdelare.scss');
  return (
    <div>
      <p className={style.textBox}>{textbox}</p>
      
      <div className={style.picS} style={{backgroundImage: 'url("'+ bytbild_m + '")'}}></div>
      <div className={style.picM} style={{backgroundImage: 'url("'+ bytbild_d + '")'}}></div>
      </div>
  );
};

export default Avdelare;




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Special/Avdelare/Avdelare.js
 **/